import { ReactElement } from 'react';
import { HeaderBlock, HeaderCell } from './TableHeader.style';
import { RequiredMark } from '../../../../../components/RequiredMark';

const TableHeader = (): ReactElement => (
  <HeaderBlock>
    <HeaderCell>No.</HeaderCell>
    <HeaderCell>
      氏名<RequiredMark>*</RequiredMark>
    </HeaderCell>
    <HeaderCell>
      電話番号<RequiredMark>*</RequiredMark>
    </HeaderCell>
    <HeaderCell>操作</HeaderCell>
    <HeaderCell></HeaderCell>
  </HeaderBlock>
);

export default TableHeader;
